import classnames from 'classnames';
import sortBy from 'lodash.sortby';
import React, { useState } from 'react';

import RefinementSelect from '../../_molecules/RefinementSelect';
import { RefinementContainer } from '@styled';

import useRegisteredEvents from '../../../hooks/useRegisteredEvents';
import { TenantsSpacesStrings } from '@general/helpers/SavedSearchesQuestionStrings';

const SearchRefinementsProperty = ({ purposeRef, densityRef, typeOfCenterRef, sizeRef, typeOfFacilityRef }) => {
    const [openMenu, setOpenMenu] = useState(null);
    const { registeredEvents } = useRegisteredEvents();
    const hasRegisteredEvents = registeredEvents && registeredEvents.length > 0;

    return (
        <div className="d-flex flex-wrap">
            <RefinementContainer className={classnames({ isOpen: openMenu === 'purpose' })}>
                <RefinementSelect
                    refinementRef={purposeRef}
                    attribute="purpose"
                    placeholder="Purpose of Space"
                    onMenuOpen={() => {
                        setOpenMenu('purpose');
                    }}
                />
            </RefinementContainer>

            <RefinementContainer className={classnames({ isOpen: openMenu === 'density' })}>
                <RefinementSelect
                    refinementRef={densityRef}
                    attribute="density"
                    placeholder="Population Density"
                    onMenuOpen={() => {
                        setOpenMenu('density');
                    }}
                />
            </RefinementContainer>

            <RefinementContainer className={classnames({ isOpen: openMenu === 'typeOfCenter' })}>
                <RefinementSelect
                    refinementRef={typeOfCenterRef}
                    attribute="typeOfCenter"
                    placeholder="Type of Center"
                    onMenuOpen={() => {
                        setOpenMenu('typeOfCenter');
                    }}
                />
            </RefinementContainer>

            <RefinementContainer className={classnames({ isOpen: openMenu === 'typeOfFacility' })}>
                <RefinementSelect
                    refinementRef={typeOfFacilityRef}
                    attribute="typeOfFacility"
                    placeholder="Type of Facility"
                    onMenuOpen={() => {
                        setOpenMenu('typeOfFacility');
                    }}
                />
            </RefinementContainer>

            <RefinementContainer className={classnames({ isOpen: openMenu === 'size' })}>
                <RefinementSelect
                    attribute="size"
                    refinementRef={sizeRef}
                    placeholder="Size of Space"
                    transformItems={items =>
                        sortBy(items, ['label']).map(item => ({
                            ...item,
                            label: TenantsSpacesStrings.size[`_${item.label.toUpperCase()}`] || item.label,
                        }))
                    }
                    customOptionTransform={values =>
                        values.map(value => TenantsSpacesStrings.size[`_${value.toUpperCase()}`] || value)
                    }
                    customReverseOptionTransform={values =>
                        values.map(value => {
                            return Object.entries(TenantsSpacesStrings.size)
                                .find(([_, val]) => val === value)?.[0]
                                ?.slice(1)
                                .toLowerCase() || value;
                        })
                    }
                    onMenuOpen={() => {
                        setOpenMenu('size');
                    }}
                />
            </RefinementContainer>

            <RefinementContainer className={classnames({ isOpen: openMenu === 'listingStatus' })}>
                <RefinementSelect
                    attribute="listingStatus"
                    placeholder="Listing Status"
                    onMenuOpen={() => {
                        setOpenMenu('listingStatus');
                    }}
                />
            </RefinementContainer>

            {hasRegisteredEvents && (
                <RefinementContainer className={classnames({ isOpen: openMenu === 'events' })}>
                    <RefinementSelect
                        attribute="events"
                        placeholder="Registered Events"
                        limit={1000}
                        transformItems={items =>
                            items
                                .filter(item => {
                                    const code = item.label;
                                    return !!registeredEvents.find(registered => registered.code === code);
                                })
                                .map(item => {
                                    const eventMatch = registeredEvents.find(
                                        registered => registered.code === item.label,
                                    );

                                    return {
                                        ...item,
                                        label: eventMatch ? eventMatch.title : item.label,
                                    };
                                })
                        }
                        customOptionTransform={values =>
                            values.map(value => {
                                const eventMatch = registeredEvents.find(registered => registered.code === value);
                                return eventMatch ? eventMatch.title : value;
                            })
                        }
                        onMenuOpen={() => {
                            setOpenMenu('events');
                        }}
                    />
                </RefinementContainer>
            )}
        </div>
    );
};

export default SearchRefinementsProperty;
